/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { createStyles, Button } from "@material-ui/core";

// TC UX
import Footer from "components/Footer/Footer.jsx";

import { Modal } from "components/Modal/Modal";
import {
  sContactMsg,
  sSupportUs,
  sContactUs,
  sBack,
  sLegal,
  sDisclaimer,
} from "assets/jss/views/ResStrings";
import { showHtmlText } from "client/views/Exercise/ExMain";
import { Disclaimer } from "client/views/Legal/Content/Disclaim";
import { followSocialButtons } from "components/Form/FormField";

import footerStyle from "assets/jss/material-kit-pro-react/components/footerStyle";
const styles = createStyles(footerStyle as any);

interface Props extends WithStyles<typeof styles> {
  route: any;
}

const PhoenixFooterBase: React.SFC<Props> = ({ classes, route }: Props) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertModal, setAlertModal] = useState(<React.Fragment />);
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const contactMsg = () => {
    setAlertModal(
      <Modal title={sContactUs} onExit={() => setShowAlert(false)}>
        {showHtmlText(sContactMsg)}
      </Modal>,
    );
    setShowAlert(true);
  };

  return (
    <React.Fragment>
      {showAlert && alertModal}
      {showDisclaimer && (
        <Modal
          wide
          title={sLegal}
          buttons={[sBack]}
          onExit={() => setShowDisclaimer(false)}>
          <Disclaimer />
        </Modal>
      )}
      {route.show ? (
        <Footer
          style={{ marginTop: "1.5rem" }}
          theme="dark"
          content={
            <div>
              <div style={{ overflow: "hidden" }}>
                <div className={classes.left}>
                  <div className={classes.inlineBlock}>
                    <Link to="/lgl/about">About</Link>
                  </div>
                  <div className={classes.inlineBlock}>
                    <Link to="/lgl/terms">Terms</Link>
                  </div>
                  <div className={classes.inlineBlock}>
                    <Link to="/lgl/policy">Policy</Link>
                  </div>
                  <div
                    className={classes.inlineBlock}
                    style={{ cursor: "pointer", opacity: 0.86 }}
                    onClick={(e) => {
                      e.preventDefault();
                      contactMsg();
                    }}>
                    Contact
                  </div>
                  <div className={classes.inlineBlock}>
                    <Link to="/sup/supp">{sSupportUs}</Link>
                  </div>
                  <div
                    className={classes.inlineBlock}
                    style={{ opacity: 0.86 }}>
                    Follow Us {followSocialButtons()}
                  </div>
                </div>
                <div className={classes.right}>
                  <img
                    src={require("assets/svg/apricot.svg")}
                    className={classes.logo}
                    alt={"Logo"}
                  />
                  <span>
                    Copyright &copy; 2019~{new Date().getFullYear()} Apricad
                    LLC, All&nbsp;Rights&nbsp;Reserved.
                  </span>
                </div>
              </div>
              <div className={classes.disclaimer}>{sDisclaimer}</div>
              <Button
                onClick={() => setShowDisclaimer(true)}
                className={classes.btnDisclaimer}
                variant="outlined"
                color="inherit">
                Disclaimer
              </Button>
            </div>
          }
        />
      ) : (
        <div />
      )}
    </React.Fragment>
  );
};

export default withStyles(styles)(PhoenixFooterBase);
